import { Col, Row } from 'react-bootstrap';
import { useItemAnalysisContext } from '../utils/itemAnalysisContext';
import StepTabs from '../../../../../components/StepTabs';
import { useNavigate } from 'react-router';

const FilterHeader = () => {
  const navigate = useNavigate();
  const { activeStep, setActiveStep, classes } = useItemAnalysisContext();

  const steps = [
    { label: 'Choose Classes' },
    { label: 'Choose Assignments' }
  ];

  const handleStepClick = (step) => {
    var selectedClasses = classes.filter(x => x.selected);
    if (step == 1 || selectedClasses?.length > 0)
      setActiveStep(step);
  };

  return (
    <>
      <Row className='align-items-center d-flex justify-content-between p-3'>
        <Col><h1 className=''>Item Analysis Report</h1></Col>
        <Col className='mb-5'>
          <StepTabs
            steps={steps}
            activeStep={activeStep}
            onClick={handleStepClick} />
        </Col>
        <Col className='d-flex  align-items-center clr-castleRed justify-content-end'>
          <button onClick={()=>navigate(-1)} id="back_button" className="btn btn-width btn-castleWhite">
            Back
          </button></Col>
      </Row>
    </>
  );
};

export default FilterHeader;